import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HistoricModule } from '@core/components/historic/historic.module';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { EquipmentMaintenanceMapperService } from './services/tab-maintenances.service';
import { UpdatedByService } from './services/updated-by.service';
import { TabMaintenancesComponent } from './tab-maintenances.component';


@NgModule({
  declarations: [
    TabMaintenancesComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    HistoricModule,
    MatProgressSpinnerModule
  ],
  exports: [
    TabMaintenancesComponent
  ],
  providers: [
    PipesModule,
    DatePipe,
    EquipmentMaintenanceMapperService,
    UpdatedByService
  ]
})
export class TabMaintenancesModule {}
